<div class="delete-reason-feedback">
  <h2 md-dialog-title>Delete Payform Reason</h2>
  <mat-dialog-content class="delete-reason-feedback-content">
    <div class="delete-reason-feedback-content-input"
         fxLayout="row"
         fxLayoutAlign="start start">
      <mat-form-field fxFlex="">
        <textarea matInput
                  matTextareaAutosize
                  matAutosizeMinRows="5"
                  matAutosizeMaxRows="5"
                  maxlength="250"
                  placeholder="If you delete this payform it will be lost forever. Please describe your reason for deleting this payform."
                  [(ngModel)]="feedback"
                  required
                  #feedbackInput="ngModel"></textarea>
        <mat-hint align="end">{{feedbackInput?.value?.length}} / 250</mat-hint>
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="delete-reason-feedback-actionbar">
    <button mat-button
            color="primary"
            (click)="cancelClicked()"
            tabindex="-1">Cancel</button>
    <button mat-button
            color="primary"
            (click)="deleteClicked()"
            tabindex="-1"
            [disabled]="!feedbackInput.valid">Delete</button>
  </mat-dialog-actions>
</div>
